/* CTA tracking (enabled by the theme layout): data-track contains the action and its location. */
(function () {
  'use strict';

  if (window.__ptTrackingInstalled) return;
  window.__ptTrackingInstalled = true;

  // Article text comes from Shopify content, independently of the theme markup.
  [
    ['.pt-article-content a[href^="tel:"]', 'click_tel_articol'],
    ['.pt-article-content a[href^="mailto:"]', 'click_email_articol'],
    ['.pt-article-content a[href^="https://wa.me/"]', 'click_wa_articol']
  ].forEach(function (rule) {
    document.querySelectorAll(rule[0]).forEach(function (link) {
      if (!link.hasAttribute('data-track')) link.setAttribute('data-track', rule[1]);
    });
  });

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var button = target.closest('[data-track]');
    if (!button) return;

    var eventName = button.getAttribute('data-track');
    if (eventName && window.dataLayer && typeof window.dataLayer.push === 'function') {
      window.dataLayer.push({ event: eventName });
    }
  });
})();
